import { render, staticRenderFns } from "./weather-settings.vue?vue&type=template&id=4557f650&"
import script from "./weather-settings.vue?vue&type=script&lang=ts&"
export * from "./weather-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports